import { createReducer } from "actionware";
import { createState } from "stateware";
import {
  fetchLenderPreferences,
  saveNewPreferenceData,
  resetToInitialState,
  persistNewPreferenceData,
  toggleBannerView,
  resetToggleBannerView,
} from "./approvalSettingActions";
import _ from "lodash";
import { AUTO_APPROVAL_ACTION_MAPPING } from "./constants";
import { message } from "antd";

const initialState = createState({
  action: "newPreference",
  newPreference: {},
  currentPreferences: [],
  isBannerVisible: false,
  bannerTitle: "",
  bannerType: "",
});

function getUpdateState(state, { action, data }) {
  let updatedPreference = _.cloneDeep(state.newPreference);

  switch (action) {
    case AUTO_APPROVAL_ACTION_MAPPING.saveNewPreference: {
      const { productCode, isChecked } = data;
      updatedPreference = {
        product_code: productCode,
        auto_approval_enabled: isChecked,
      };
      break;
    }
    default:
      break;
  }

  return updatedPreference;
}

export default createReducer(initialState)
  .on(fetchLenderPreferences, (state, currentPreferences) => {
    return initialState.copy({ ...state, currentPreferences });
  })
  .onError(fetchLenderPreferences, (state, error) => {
    message.error("Fetching lender preferences failed", error, 10);
    initialState.copy({
      errorMessage: "Fetching lender preferences failed",
      ...state,
    });
  })

  .on(saveNewPreferenceData, (state, data) => {
    const newPreference = getUpdateState(state, data);
    return initialState.copy({ ...state, newPreference });
  })

  .on(persistNewPreferenceData, (state) => {
    return initialState.copy({
      ...state,
    });
  })

  .on(resetToInitialState, (state, data) => {
    return initialState.copy({
      ...state,
      newPreference: {},
    });
  })

  .on(toggleBannerView, (state, data) => {
    return initialState.copy({
      ...state,
      isBannerVisible: data.showFlag,
      bannerTitle: data.title,
      bannerType: data.type,
    });
  })

  .on(resetToggleBannerView, (state, data) => {
    return initialState.copy({
      ...state,
      isBannerVisible: false,
      bannerTitle: "",
      bannerType: "",
    });
  });
